import thumbnailmap from '../thumbnailmap/thumbnailmap.vue';

export default{
	name: 'thumbnailmapList',
	components: {
       thumbnailmap,
    },
    props: {
        selectedLang: { type: String },
        homePreviewMaps: { type: Array },
        maxLengthTitle: {type: Number},
        maxLengthDesc: {type: Number},
        isMobile: {type: Boolean},
    },
    methods:{
        clonarMapa: function(element){
            this.$emit('clonarMapa', {mapa: element});
        }
    }
};



// WEBPACK FOOTER //
// ./src/shared/components/thumbnailmap-list/thumbnailmap-list.js